import { FC } from "react";
import styled from "styled-components";
type child = JSX.Element | JSX.Element[];

interface IBadge {
  children: child | string | number;
  icon: child;
}

const StyledBadgeWraper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: max-content;
  padding: 4px 17px;
  border-radius: 8px;
  background-color: var(--badge-background);
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 1.5em;
  color: var(--badge-link);
`;

const StyledIcon = styled.span`
  display: inline-block;
  margin-right: 10px;
`;

const StyledBadgeText = styled.span`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  max-width: 85px;
  text-overflow: ellipsis;

  @media (min-width: 480px) {
    max-width: 235px;
  }

  @media (min-width: 576px) {
    max-width: 435px;
  }

  @media (min-width: 768px) {
    max-width: 400px;
  }
`;

const Badge: FC<IBadge> = (props): JSX.Element => {
  const { children, icon } = props;

  return (
    <StyledBadgeWraper>
      <StyledIcon>
        {icon}
      </StyledIcon>
      <StyledBadgeText>{children}</StyledBadgeText>
    </StyledBadgeWraper>
  );
};

export default Badge;
